import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'

import { EnvironmentService } from '@surgetech-eu/core'
import { environment } from 'src/environments/environment'

const KEYE = 'eyedes'
const GALVMAN = 'galvman'

export class GalvmanPlayerPermissions {
    canActivate(roles: string): boolean {
        return roles.includes(KEYE) || roles.includes(GALVMAN)
    }
}

@Injectable()
export class GalvmanPlayerGuard {
    constructor(
        private environment: EnvironmentService,
        private permissions: GalvmanPlayerPermissions
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        return this.permissions.canActivate(this.environment.get().type)
    }

    static get isKEYEorGALVMAN() {
        const roles = window['__env']?.type || environment.type
        return roles.includes(KEYE) || roles.includes(GALVMAN)
    }
}
